import { makePossibleCoordinate } from "./types";
import { gridSize } from "../config";
import { possibleDirectionVector, } from "./types";
export function randomizeFrom1ToN(N) {
    return Math.floor(Math.random() * N) + 1;
}
export function randomizeFrom0ToNMinus1(N) {
    return Math.floor(Math.random() * N);
}
export const directionToVectorDict = {
    Up: possibleDirectionVector[0],
    Down: possibleDirectionVector[1],
    Right: possibleDirectionVector[2],
    Left: possibleDirectionVector[3],
};
export const oppositeDirectionDictionary = {
    "Up": "Down",
    "Down": "Up",
    "Left": "Right",
    "Right": "Left"
};
export function allCoordinateMaker(gridSize) {
    let allCoordinateList = [];
    for (let i = 1; i <= gridSize; i++) {
        for (let j = 1; j <= gridSize; j++) {
            allCoordinateList.push({ x: makePossibleCoordinate(i), y: makePossibleCoordinate(j) });
        }
    }
    return allCoordinateList;
}
export const allCoordinateList = allCoordinateMaker(gridSize);
export function fetchItemFromLocalStorage(key) {
    let candidateResult = localStorage.getItem(key);
    if (candidateResult !== undefined && candidateResult !== null) {
        return JSON.parse(candidateResult);
    }
    else {
        return undefined;
    }
}
export function updateBindingFirstElement(newKey, changedDirection, previousBinding) {
    Object.keys(previousBinding).forEach((direction) => {
        if (direction === changedDirection) {
            return;
        }
        if (previousBinding[direction][0] === newKey) {
            previousBinding[direction][0] = "";
        }
    });
    previousBinding[changedDirection][0] = newKey;
    return previousBinding;
}
